import DateTimeUtils from "../../gd/utils/datetime-utils"
import PortfolioCondition from "./condition/portfolio-condition"
import ProjectCollectionActions from "./actions/actions"
import ModelProto from "../model-proto"
import {NavigationSectionType} from "../navigation/@const"
import {EntityType} from "../../gd/const/item"
import {EVENT_BUS_SESSION_PORTFOLIO_CHANGED} from "./events"
import getViewLocationOptions from "../custom-view/actions/get-view-location-options"
import {ViewType} from "../../gd/const/views/view-type"
import {PortfolioUserAccess} from "../../gd/const/portfolio"
import {PortfolioConditionType} from "./condition/@const";
import {SystemStatusGroup} from "../../gd/const/system-status";

const debug = false
// const debug = "ProjectCollectionModel"

export default class ProjectCollectionModel extends ModelProto {


    public id               : ID
    public name             : string
    public settings         : PortfolioCondition
    public role             : any  // 1 = OWner ?
    public ownerUserId      : ID
    public users            : any[] // {userId, access}
    public views            : any
    public sharedViewId     : ID
    public momentCreated    : Moment

    // is true when all properties are loaded (not only from initial session reset)
    public isFullyLoaded    : boolean = false

    public isInStructure    : boolean = false

    constructor(data:any) {

        super(data)

        this.id                 = data['id']
        this.name               = data['name']
        this.settings           = new PortfolioCondition(data['settings'])
        this.role               = data['role'] // present in session object
        this.ownerUserId        = data['ownerUserId']
        this.users              = _.get(data, 'users', [])
        // this._addUsersFromSharedUsers(data['sharedUsers'])

        this.views              = data['views']
        this.sharedViewId       = data['sharedViewId']
        this.momentCreated      = data['momentCreated'] ? DateTimeUtils.datetimeToMoment(data['momentCreated']) : moment()

    }

    get entityType() { return EntityType.PORTFOLIO }

    get hasAccess()        {
        return this.role === 1 ||
            !!_.find(this.users, user=>user.userId === gd.user.id)
    }

    get isFullAccessUser() {
        return this.role === 1
    }

    get isEditorAccessUser() {
        return this.role === 1 ||
            _.find(this.users, user=>user.userId === gd.user.id)?.access === PortfolioUserAccess.FULL
    }

    get actions(): ProjectCollectionActions {
        return new ProjectCollectionActions(this)
    }

    get isSharedWithMe():boolean {
        return this.role != 1
    }

    applyDelta(data:any) {

        debug && console.log("applyDelta()", data)

        let isChanged = false

        _.mapKeys(data, (value ,key)=>{
            if (key === 'id') return;

            debug && console.log(debug, "applyDelta key=", key, "value=", value)

            switch (key) {
                case 'momentCreated':
                    // should not ever happen
                    // this[key] = Moment.isMoment(value) ? value : DateTimeUtils.dateToMoment(value)
                    // isChanged = true
                    break

                case 'settings':
                    this[key] = new PortfolioCondition(value)
                    isChanged = true
                    break

                case 'users':
                    // this._addUsersFromSharedUsers(value)
                    this.users  = value
                    isChanged = true
                    break

                // case 'sharedUsers':
                //     this._addUsersFromSharedUsers(value)
                //     isChanged = true
                //     break

                default             :
                    // @ts-ignore
                    this[key] = value
                    isChanged = true
            }

        })

        debug && console.log(debug, "afterDeltaApplied this=", this)

        return isChanged
    }

    updateToFull(data:any) {
        this.applyDelta(data)
        this.isFullyLoaded = true
    }

    get url() {
        return 'portfolio/{0}'.f(this.id)
    }

    open() {
        gd.goTo('portfolio/{0}'.f(this.id))
    }

    // check if this portfolio is open right now
    get isOpen() {
        const fragment = gd.router.history.fragment || ''
        return _.startsWith(fragment, 'portfolio/') && fragment.includes(this.id)
    }

    toJSON = () => {
        let res : JSONObject = {
            name    : this.name,
            views   : this.views
        }

        const settings = this.settings.toJSON()
        if (!_.isEmpty(settings))           res.settings        = settings
        if (!_.isEmpty(this.sharedViewId))  res.sharedViewId    = this.sharedViewId

        res.users       = !_.isEmpty(this.users) ? this.users : []

        return res
    }

    save(): any {
        debug && console.log(debug, "save: save project collection", this)

        gd.bus.triggerEvent(EVENT_BUS_SESSION_PORTFOLIO_CHANGED)

        return gd.api.Portfolio.update(this.id, this.toJSON())
    }


    // Custom View interface...
    get locationOptions():Option[] {
        return getViewLocationOptions(ViewType.PROJECTS_PORTFOLIO)
    }

    get location():NavigationSectionType {
        let res = gd.user.settings.navigation.getPortfolioLocation(this.id)
        if (res === NavigationSectionType.PROJECTS && !gd.spaces.projects.enabled) {
            res = NavigationSectionType.HOME
        }

        return res
    }

    set location(viewLocation: NavigationSectionType) {
        gd.user.settings.navigation.setPortfolioLocation(this.id, viewLocation)
        gd.user.settings.save()

        gd.bus.triggerEvent(EVENT_BUS_SESSION_PORTFOLIO_CHANGED)
    }

    get isManual():boolean {
        return this.settings.type === PortfolioConditionType.MANUAL
    }

    get includesArchived():boolean {
        return this.settings.systemStatusesGroup !== SystemStatusGroup.OPEN
    }

}